import React, { Component } from "react";
import { l } from "../functions";
import { connect } from "react-redux";
import { deleteLayout, changePage } from "../core/redux/api/pages";
import Icons from "./Icons";
import { imagePhp } from "../consts";

const mapStateToProps = (state) => {
  return {
    templates: state.rootReducer.templates || {},
  };
};

class PageTemplates extends Component {
  constructor(props) {
    super(props);

    this.defaultState = {
      currentTemplate: null,
      templateDatas: {},
    };

    this.state = this.defaultState;
  }

  getLayouts = (page) => {
    if (
      page &&
      this.props.templates &&
      this.props.templates[page] &&
      this.props.templates[page].layouts
    )
      return this.props.templates[page].layouts;
    else return null;
  };

  render() {
    console.log(this.getLayouts(this.props.target));
    return (
      <div className="page-dialog">
        <div className="head">
          <h3>{l("Import template")}</h3>
          <Icons
            icon="time"
            onClick={() => {
              this.setState(this.defaultState);
              this.props.onClose();
            }}
          />{" "}
          {this.state.currentTemplate && (
            <button
              className="new-item"
              onClick={() => {
                this.props.onSubmit(this.state.templateDatas, () => {
                  this.setState(this.defaultState);
                });
              }}
            >
              <Icons icon="check" />
            </button>
          )}
        </div>
        <ul className="tab-body templates-section">
          <li>
            {(this.getLayouts(this.props.target) &&
              this.getLayouts(this.props.target).length && (
                <div className="layouts-container">
                  {this.getLayouts(this.props.target).map((layout, key) => (
                    <div
                      key={key}
                      style={{
                        backgroundImage: "url(" + imagePhp + layout.img + ")",
                      }}
                      onClick={() => {
                        this.setState({
                          currentTemplate: layout.id,
                          templateDatas: {
                            id: this.props.targetId,
                            payload: layout.json,
                            screenshot: layout.img,
                          },
                        });
                      }}
                      className={
                        this.state.currentTemplate === layout.id ? "active" : ""
                      }
                    >
                      <p>{layout.title}</p>
                    </div>
                  ))}
                </div>
              )) || (
              <div style={{ margin: 15 }} className="gk-error-message inline">
                <p>{l("There's no layout. Please create new layout first.")}</p>
              </div>
            )}
          </li>
        </ul>
      </div>
    );
  }
}

export default connect(mapStateToProps, { changePage, deleteLayout })(
  PageTemplates
);
